import React from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import ReactTelephoneInput from 'react-telephone-input';
import CheckBox from 'components/CheckBox/CheckBox';
import flags from './flags.png';
import './PostContactDetails.scss';

const PostContactDetails = ({
  email = true,
  none = false,
  onChangePhoneNumber,
  onToggleEmail,
  onToggleNone,
  onTogglePhone,
  onToggleSms,
  phone = true,
  phoneNumber = '',
  sms = true,
}) => {
  return (
    <div className="lato-regular" id="post-brief-contact-details">
      <p className="fs-15 lato-bold mb">Contact details</p>
      <p className="mb++ fs-15">
        How would you like freelance experts to get in contact with you?
      </p>
      <div>
        <FormGroup controlId="formContactInfo">
          <div className="fs-15" style={{ marginBottom: '5px' }}>
            <CheckBox
              tickColor="#0ee2b0"
              size="30px"
              checked={email}
              onClick={onToggleEmail}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            <span
              style={{
                marginLeft: '10px',
                verticalAlign: 'middle',
                cursor: 'pointer',
              }}
              onClick={onToggleEmail}
            >
              Email
            </span>
          </div>
          <div className="fs-15" style={{ marginBottom: '5px' }}>
            <CheckBox
              tickColor="#0ee2b0"
              size="30px"
              checked={phone}
              onClick={onTogglePhone}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            <span
              style={{
                marginLeft: '10px',
                verticalAlign: 'middle',
                cursor: 'pointer',
              }}
              onClick={onTogglePhone}
            >
              Phone
            </span>
          </div>
          <div className="fs-15" style={{ marginBottom: '5px' }}>
            <CheckBox
              tickColor="#0ee2b0"
              size="30px"
              checked={sms}
              onClick={onToggleSms}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            <span
              style={{
                marginLeft: '10px',
                verticalAlign: 'middle',
                cursor: 'pointer',
              }}
              onClick={onToggleSms}
            >
              WhatsApp or SMS
            </span>
          </div>
          <div className="fs-15" style={{ marginBottom: '5px' }}>
            <CheckBox
              tickColor="#0ee2b0"
              size="30px"
              checked={none}
              onClick={onToggleNone}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            <span
              style={{
                marginLeft: '10px',
                verticalAlign: 'middle',
                cursor: 'pointer',
              }}
              onClick={onToggleNone}
            >
              {'On Twine (keep my details private)'}
            </span>
          </div>
        </FormGroup>
        <FormGroup
          controlId="post-brief-phone-number"
          id="post-brief-phone-number"
        >
          <ControlLabel className="fs-15">Enter your phone number</ControlLabel>
          <div style={{ width: '250px' }}>
            <ReactTelephoneInput
              defaultCountry="us"
              preferredCountries={['us', 'gb', 'in']}
              flagsImagePath={flags}
              value={phoneNumber}
              onChange={(number) => onChangePhoneNumber(number)}
            />
          </div>
        </FormGroup>
      </div>
      <div style={{ clear: 'both' }} />
    </div>
  );
};

export default PostContactDetails;
